var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-page',{attrs:{"columns":_vm.columns,"headers":_vm.headers,"sort":"id","title":"Link List","icon":"mdi-link","stateendpoint":"links.allowedLinks","show-default-action-buttons":false,"show-add-button":false,"actions":_vm.actions}})
}
var staticRenderFns = []

export { render, staticRenderFns }